import {createFileRoute} from '@tanstack/react-router';
import ClubTeamsPage from '../../../../players/ClubTeamsPage.tsx';

export const Route = createFileRoute('/_app/volleyball/teams/')({
    component: () => <ClubTeamsPage sport="volleyball" />,
});
